<template>
    <x-page title="Edit Validation Rules">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <validation-rule-form id="validation-rule-form"
            v-if="resource"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="validation-rule-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import ValidationRuleForm from './ValidationRuleForm.vue'

export default {
    components: {
        ValidationRuleForm,
        XPage,
        XBackButton,
        XSubmitButton,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/validation-rules/${this.$route.params.id}`)
                .then(response => {
                    this.resource = response.data.data
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/validation-rules/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} updated!`,
                    })
                    this.$router.back()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
            }).finally(() => {
                this.isLoading = false
            })
        },
    },
}
</script>